import React from 'react';

import { getProgressSteps, stepsContent } from '../../helpers/returns';

import ProgressIcon from '../ProgressIcon';

const renderProgress = steps => (
  steps.map((step, index) => (
    <div className={`progress progress--${index} ${step.className}`} key={step.id}>
      <div className="progress__icon">
        <div className="icon-circle">
          <ProgressIcon type={step.icon} />
        </div>
      </div>

      <div className="hgroup progress__title">
        <h5>{step.title}</h5>
        {step.isComplete && <p className="body1">{step.completedDateString}</p>}
        {step.showMultipleStatus && <p>{step.multipleStatus}</p>}
      </div>
    </div>
  ))
);

const ReturnProgress = (props) => {
  const steps = getProgressSteps(props, stepsContent);

  return (
    <div className="return-progress">
      {renderProgress(steps)}
    </div>
  );
};

export default ReturnProgress;
